export default {
  SET_STRIPE_SESSION(state, session) {
    state.stripe_session = session;
  },
  SET_CHECKOUT_LINK(state, link) {
    state.checkout_link = link;
  },
};
